let menuItems = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");
 
for (const menuItem of menuItems) {
    menuItem.addEventListener("mouseover", () => {
        menuItem.setAttribute("open", true);
        
       menuItem.addEventListener("mouseleave", () => {
            menuItem.removeAttribute("open");
        });
 
      menuItem.querySelector("ul").addEventListener("mouseleave", () => {
            menuItem.removeAttribute("open");
        });
    });
}